// Resize/compress an image in the browser before upload. Photos are stored in
// D1 (1MB row limit), so we cap dimensions and shrink quality until the file is
// comfortably small. Also makes the public site load faster.
// Falls back to the original file if the browser can't decode it (e.g. HEIC)
// and it is already small enough.
export async function optimizeImage(
  file,
  { maxDim = 1600, quality = 0.82, maxBytes = 700 * 1024 } = {}
) {
  if (!file || !file.type || !file.type.startsWith("image/")) return file;

  try {
    const bitmap = await createImageBitmap(file);
    let width = bitmap.width;
    let height = bitmap.height;
    const scale = Math.min(1, maxDim / Math.max(width, height));
    width = Math.max(1, Math.round(width * scale));
    height = Math.max(1, Math.round(height * scale));

    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(bitmap, 0, 0, width, height);
    if (bitmap.close) bitmap.close();

    const toBlob = (q) => new Promise((r) => canvas.toBlob(r, "image/jpeg", q));

    let q = quality;
    let blob = await toBlob(q);
    while (blob && blob.size > maxBytes && q > 0.4) {
      q -= 0.12;
      blob = await toBlob(q);
    }
    return blob || file;
  } catch {
    // Undecodable (e.g. HEIC) — keep the original if it's small enough.
    return file;
  }
}
